import sc from 'styled-components';
import {UnifonTheme} from '@phonectas/unifon-ui-kit/dist/theme/theme';

// badges
export type BoxStatus = 'ok' | 'warning' | 'error';

// const statusStyles = {
//     ok: css`
//         background: #DFF5E3;
//         color: #256029;
//         border-color: #4CAF50;
//     `,
//     warning: css`
//         background: #FFF8E1;
//         color: #8D6E00;
//         border-color: #FFC107;
//     `,
//     error: css`
//         background: #FDEAEA;
//         color: #B71C1C;
//         border-color: #F44336;
//     `,
// };

export const BoxContainer = sc.div<{theme?: UnifonTheme}>`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
	padding: 0 10px;
    background: #fff;
    border-left: ${({theme}) => theme['palette'].primary} solid 3px;
    position: relative;
    width: 100%;
`;

export const BoxMessage = sc.div<{theme?: UnifonTheme}>`
    flex: 1;
    color: #00205B;
    font-size: 16px;
    line-height: 1.5;
    align-self: center;
    > div {
        border-left: 3px solid ${({theme}) => theme['palette'].primary};
        padding-left: 12px;
    }
`;

export const BoxBadge = sc.div<{$status: BoxStatus, theme?: UnifonTheme}>`
    border-radius: 8px;
    padding: 12px 20px;
    white-space: nowrap;
    align-self: center;
    background: ${({$status}) =>
		$status === 'ok'
			? '#EAF7EC'
			: $status === 'warning'
				? '#FFF8E1'
				: '#FDEAEA'};
    color: #00205B;
    border: none;
    position: relative;
    display: flex;
    align-items: center;
    min-height: 48px;

    &::before {
        content: '';
        display: block;
        height: 100%;
        width: 4px;
        border-radius: 3px 0 0 3px;
        background: ${({$status, theme}) =>
		$status === 'ok'
			? (theme?.palette?.success ?? '#2DBB55')
			: $status === 'warning'
				? (theme?.palette?.warning ?? '#FFC107')
				: (theme?.palette?.error ?? '#F44336')};
        position: absolute;
        left: 0;
        top: 0;
    }
    padding-left: 24px;
`;

// boxes

export const Card = sc.div<{checked: boolean}>`
    // border: 2px solid ${({checked}) => (checked ? '#1A237E' : '#E3E8F0')};
    border: ${({checked, theme}) => checked ? `2px solid ${theme['palette'].success}` : '2px solid transparent'};
    border-radius: 10px;
    padding: 8px;
    background: rgba(222, 233, 251, 0.5);
    min-width: 290px;
    min-height: 206px;
    /* margin: 8px; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
    transition: border 0.2s, background 0.2s;
`;

export const Header = sc.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const Title = sc.span`
    font-weight: 600;
    font-size: 18px;
`;

export const Price = sc.div`
    font-weight: 700;
    font-size: 24px;
    margin: 8px 0 0 0;
    span {
        font-weight: 400;
        font-size: 16px;
    }
`;

export const InfoRow = sc.div`
    margin: 8px 0;
    color: #64748B;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 16px;
`;

export const Description = sc.div`
    color: #64748B;
    font-size: 16px;
`;

export const Checkbox = sc.input.attrs({type: 'checkbox'})`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 24px;
    height: 24px;
    margin-left: 8px;
    // cursor: pointer;
    border: 2px solid ${({theme}) => theme['palette'].secondary};
    border-radius: 4px;
    background-color: white;
    position: relative;
    
    &:checked {
        background-color: ${({theme}) => theme['palette'].success};
        border-color: ${({theme}) => theme['palette'].success};
    }
    
    &:checked::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 16px;
        font-weight: bold;
    }
`;